// extracted by mini-css-extract-plugin
export default {"emailcom":"Login_emailcom__mH2B5","loginheader":"Login_loginheader__+QWmI","signup":"Login_signup__qNXwk"};